export default function getResource(label) {
    const resources = {
        title: 'Account Deactivated',
        confirmText: 'OK'
    };

    return resources[label];
}
